import React, { useState } from "react";
import Loader from "../../../Common/Loader/loader";
import { useLocation, useNavigate } from "react-router-dom";
import CustomDataTable from "../../../Common/ReportTable/ReportTable";
import ExcelJS from "exceljs";
import { Formik, Form, Field } from "formik";
import { formattedDate, getCurrentDateTime1, getCurrentISTDate } from "../../../Common/helper/helpar";
const MultiClearenceInnerGvpReport = () => {
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const {data,formatDate,shiftName }= location.state;
  const navigate = useNavigate();
  const [gvpList, setGvpList] = useState(data);
  const scvReportColumns = [
    {
      name: "S.No",
      selector: (row) => row["sno"],
      sortable: true,
      format: (row, rowIndex) => rowIndex + 1,
      width: "100px",
    },
    {
      name: "Corporation",
      selector: (row) => row["corporationName"],
      cell: (row) => <span>{row["corporationName"] || "N/A"}</span>,
      sortable: true,
      width: "130px",
    },
    {
      name: "Circle",
      selector: (row) => row["circleName"],
      cell: (row) => (
        <span
        // style={{ color: "blue", cursor: "pointer" }}
        //   onClick={() => handleZoneClick(row["zoneId"])}
        >
          {row["circleName"]}
        </span>
      ),
      sortable: true,
    },
    {
      name: "No. of Existing GVPs",
      width: "15%",
      selector: (row) => row["existingCp"],
      cell: (row) => (
        <span
        // style={{ color: "blue", cursor: "pointer" }}
        //   onClick={() => handleZoneClick(row["zoneId"])}
        >
          {row["existingCp"]}
        </span>
      ),
      sortable: true,
    },
    // {
    //   name: "Unique GVPs Cleared",
    //   width:"15%",
    //   selector: (row) => (
    //     <span
    //     // style={{ color: "blue" }}
    //     >
    //       {row["uniqueClearedCp"]}</span>
    //   ),
    //   sortable: true,
    // },
    {
      name: "Total GVPs Cleared",
      width: "15%",
      selector: (row) => row["totalClearedCp"],
      cell: (row) => (
        <span
        // style={{ color: "blue" }}
        >
          {" "}
          {row["totalClearedCp"]}
        </span>
      ),
      sortable: true,
    },
    {
      name: "1 Time",
      selector: (row) => row["oneTimeCp"],
      cell: (row) => (
        <span
        //  style={{ color: "blue" }}
        >
          {row["oneTimeCp"]}
        </span>
      ),
      sortable: true,
    },
    {
      name: "2 Times",
      selector: (row) => row["twoTimeCp"],
      cell: (row) => (
        <span
        // style={{ color: "blue" }}
        >
          {row["twoTimeCp"]}
        </span>
      ),
      sortable: true,
    },
    {
      name: "3 Times",
      selector: (row) => row["threeTimeCp"],
      cell: (row) => (
        <span
        // style={{ color: "blue" }}
        >
          {row["threeTimeCp"]}
        </span>
      ),
      sortable: true,
    },
    {
      name: ">3 Times",
      width: "15%",
      selector: (row) => row["moreThreeTimeCp"],
      cell: (row) => (
        <span
        // style={{ color: "blue" }}
        >
          {row["moreThreeTimeCp"]}
        </span>
      ),
      sortable: true,
    },
  ];

  const downloadAsExcel = async () => {
    // Create a new workbook and add a worksheet
    const currentDate = new Date();
    const formattedDates = `${currentDate.getDate()}-${
      currentDate.getMonth() + 1
    }-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const cumulativeHeadingReport = 
    `GVPs Circle Wise Multiple Clearance Report ${formatDate?formattedDate(formatDate):getCurrentISTDate()} - ${shiftName} - (at ${getCurrentDateTime1()})`

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Zones");

    // Define styles
    const boldFont = { bold: true };

    // Add row for download date and time
    const downloadDateTime = `Reported on: ${formattedDates} ${formattedTime}`;
    const dateTimeRow = worksheet.addRow(["", "", downloadDateTime, "", ""]);
    worksheet.mergeCells(1, 3, 1, 5);
    dateTimeRow.getCell(3).font = boldFont; // Set style for the cell
    dateTimeRow.getCell(3).alignment = { horizontal: "center" }; // Center align the cell content
    dateTimeRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      if (colNumber >= 3 && colNumber <= 5) {
        // Apply styles to download date and time cells
        cell.font = boldFont;
        cell.alignment = { horizontal: "center" };
      }
    });

    // Add row for cumulative heading report
    const cumulativeHeadingRow = worksheet.addRow([
      "",
      "",
      cumulativeHeadingReport,
      "",
      "",
    ]);
    worksheet.mergeCells(2, 3, 2, 6);
    cumulativeHeadingRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      if (colNumber >= 3 && colNumber <= 7) {
        // Apply styles to cumulative heading report cells
        cell.font = boldFont;
        cell.alignment = { horizontal: "center" };
      }
    });

    // Add empty row for spacing
    worksheet.addRow([""]);

    // Add table header row with bold font
    const tableHeaderRow = worksheet.addRow([
        "S.No",
        "Corporation",
        "Circle",
        "No. of Existing GVPs",
        "Total GVPs Cleared",
        "1 Time",
        "2 Times",
        "3 Times",
        ">3 Times",
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        cell.font = boldFont;
        cell.alignment = { horizontal: "left" }; // Left align the cell content
        if (colNumber >= 1 && colNumber <= 12) {
            // Apply background color only to specific cells
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "F6B1B1" } // Red background color
            };
        }
    });

    // Add data rows
    gvpList.forEach((item, index) => {
        worksheet.addRow([
            index + 1,
            item.corporationName?? "N/A",
            item.circleName?? "N/A",
            item.existingCp?? "N/A",
            item.totalClearedCp?? "N/A",
            item.oneTimeCp?? "N/A",
            item.twoTimeCp?? "N/A",
            item.threeTimeCp?? "N/A",
            item.moreThreeTimeCp?? "N/A",
        ]).eachCell({ includeEmpty: true }, (cell, colNumber) => {
            if (colNumber >= 1 && colNumber <= 12) {
                // Align the columns from 1 to 4 to the left
                cell.alignment = { horizontal: "left" };
            } else {
                // Align the rest of the columns to the center
                cell.alignment = { horizontal: "center" };
            }
        });
    });

    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 23 },
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "MultiClearanceInnerReport.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };
  const filterFields = {
    searchCircle: "",
    searchVehicleNumber: "",
    searchVehicleTypeName: "",
  };
  const searchReportedAtVehicleHandler = (values) => {
    const termCircle = values.searchCircle
      ? values.searchCircle.toLowerCase()
      : "";

    const filteredData = data.filter((item) => {
      const circleName = item?.circleName ? item.circleName.toLowerCase() : "";

      const matchesCircle = !termCircle || circleName.includes(termCircle);

      return matchesCircle;
    });
    setGvpList(filteredData);
  };
  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="card mt-3">
              <div className="card-body">
              <div className="page-header">
            <div className="d-flex justify-content-between mt-3">
            <Formik initialValues={filterFields}>
                      {({ handleChange, values }) => (
                        <Form>
                          <div className="row">
                            <div className="col-md-12">
                              <div className="form-group">
                                <Field
                                  name="searchCircle"
                                  placeholder="Search Circle"
                                  type="text"
                                  className="form-control bg-white"
                                  onInput={(e) => {
                                    handleChange(e);
                                    searchReportedAtVehicleHandler({
                                      ...values,
                                      searchCircle: e.target.value,
                                    });
                                  }}
                                />
                              </div>
                            </div>
                         
                            
                          </div>
                        </Form>
                      )}
                    </Formik>
                    <div className="d-flex">
                      <div>
                      <button className="btn btn-secondary me-2"
                onClick={() => navigate(-1)}
              >
                Back
              </button>
                      </div>
                     
              <div>
              <button
                className="btn btn-excel"
                onClick={downloadAsExcel}
              >
               <i class="fa-solid fa-file-excel me-1 icon-container"></i> Excel
              </button>
              </div>
                    </div>
                  </div>
                </div>

                <div className="top-header">
                  <span>GVPs Circle Wise Multiple Clearance Report {formatDate?formattedDate(formatDate):getCurrentISTDate()} - {shiftName} - (at {getCurrentDateTime1()})</span>
                </div>

                <CustomDataTable data={gvpList} columns={scvReportColumns} />
              </div>
            </div>
          </div>
        </div>
      </div>
      {isLoading && <Loader />}
    </>
  );
};

export default MultiClearenceInnerGvpReport;
